/* eslint-disable no-useless-escape */
import React from "react";
import globalData from "@/content/global/global.json";
import {
  HybridTooltipProvider,
  HybridTooltip,
  HybridTooltipTrigger,
  HybridTooltipContent,
} from "@/components/ui/hybrid-tooltip";

export default function TextTooltip({ text, ...props }) {
  const tooltips = globalData.tooltips.tooltips;

  // Function to process text and wrap matching words with tooltips
  const processTextWithTooltips = (inputText) => {
    if (!inputText || !tooltips || tooltips.length === 0) {
      return inputText;
    }

    // Create a map of words to their tooltip data for quick lookup
    const tooltipMap = {};
    tooltips.forEach((tooltip) => {
      // Store the full tooltip object for each word (lowercase key)
      tooltipMap[tooltip.word.toLowerCase()] = tooltip;
    });

    // Split text into words while preserving whitespace and punctuation

    const textParts = inputText.split(
      /(\s+|[.,!?;:"'()\[\]{}|\\\/\-_+=*&^%$#@~`<>])/
    );

    const processedParts = textParts.map((part, index) => {
      // Clean the part to check for tooltip matches (remove punctuation for matching)
      const cleanPart = part
        .replace(/[.,!?;:"'()\[\]{}|\\\/\-_+=*&^%$#@~`<>]/g, "")
        .toLowerCase();

      // Check if this cleaned part matches any tooltip word
      if (tooltipMap[cleanPart] && part.trim() !== "") {
        const tooltipData = tooltipMap[cleanPart];

        return (
          <HybridTooltip key={index}>
            <HybridTooltipTrigger className="underline decoration-dotted decoration-primary-500 underline-offset-2 cursor-help">
              {part}
            </HybridTooltipTrigger>
            <HybridTooltipContent className="max-w-[250px] lg:max-w-[400px] p-3 [&>div]:flex [&>div]:flex-col [&>div]:gap-2">
              {/* {tooltipData.title ? ( */}
              <div>
                {tooltipData?.title && (
                  <h6 className="!font-bold !leading-[170%]">
                    {tooltipData?.title}
                  </h6>
                )}
                {tooltipData?.description && (
                  <p className="p text-[15px] font-normal">
                    {tooltipData?.description}
                  </p>
                )}
              </div>
              {/* ) : (
                <p>{tooltipData.description}</p>
              )} */}
            </HybridTooltipContent>
          </HybridTooltip>
        );
      }

      return part;
    });

    return processedParts;
  };

  const processedText = processTextWithTooltips(text);

  return <p {...props}>{processedText}</p>;
}
